// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2_zy2","muteIcon":"styles_muteIcon__wTxWf","noSound":"styles_noSound__3wb47"};